import type { HelpFile } from '../../types/help'
import { ApprovalPolicyCreateTestIds } from '../../../testids/ApprovalPolicyCreateTestIds'

export const approvalPolicyCreateHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyCreateTestIds.approvalPolicyCreatePage]:
      'Neue Genehmigungspolicy anlegen. Policy-Typ wählen, übereinstimmende Bedingungen definieren und die geordneten Genehmigungsschritte hinzufügen, die Anträge durchlaufen müssen.',
  },
}
